import { FunctionComponent } from "react";
import DashboardPage from "./pages/DashboardPage";
import ComponentsPage from "./pages/ComponentsPage";
// import NotificationsPage from "./pages/NotificationsPage";
import LoginPage from "./pages/LoginPage";
import MapPage from "./pages/MapPage";

export interface NavItem
{
    path: string;
    redirect?: string;
    label?: string;
    icon?: string;
    hideOnNav?: boolean;
    exact?: boolean;
    private?: boolean;
    component?: FunctionComponent<any>;
}

export const navigation = Object.freeze<NavItem[]>([
    {
        path: "/",
        redirect: "/dashboard",
        hideOnNav: true,
        exact: true
    },
    {
        path: "/dashboard",
        label: "Dashboard",
        icon: "dashboard",
        private: true,
        exact: true
    },
    {
        path: "/dashboard/:componentId?",
        hideOnNav: true,
        private: true,
        component: DashboardPage
    },
    {
        path: "/map",
        label: "Map",
        icon: "public",
        private: true,
        component: MapPage
    },
    {
        path: "/components",
        label: "Components",
        icon: "format_list_bulleted",
        private: true,
        component: ComponentsPage
    },
    // {
    //     path: "/notifications",
    //     label: "Notifications",
    //     icon: "notifications",
    //     private: true,
    //     component: NotificationsPage
    // },
    {
        path: "/login",
        hideOnNav: true,
        exact: true,
        component: LoginPage
    },
]);